import styled from 'styled-components'

export const SuccessContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: ${({ $isMobile }) => ($isMobile ? '24px 24px' : '80px 104px')};
`

export const Content = styled.p`
  display: flex;
  font-size: 16px;
  font-weight: 400;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.neutralW70};
`
export const Title = styled.h2`
  display: flex;
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW100};
`
export const ContentEmail = styled.p`
  display: flex;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const ContentLink = styled.span`
  display: flex;
  font-size: 16px;
  font-weight: 400;
  margin-top: 16px;
  padding-left: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.interact70};
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
`
export const RequirementWrapper = styled.div`
  margin: 8px 0 24px 0;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const PasswordTips = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$isInvalid
      ? props.theme.colors.neutralW70
      : props.theme.colors.success60};
  /* margin-bottom: 4px; */
`

export const IconWrapper = styled.div`
  margin-right: 2px;
`
export const GoBackOption = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  color: ${({ theme }) => theme.colors.neutralW80};
  cursor: pointer;
  margin-bottom: 16px;

  p {
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutralW100};
  }
`
export const ContentWrapper = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.neutralW70};
`
